import { Component, OnInit } from '@angular/core';
import { SectionBase } from '../../../components/section/section-base';
import { CessionSectionConfig } from './cession-section.config';
import { CessionStateService } from '../../../../core/services/impl/section-services/cession-service/cession-state.service';
import { CessionSectionConsts } from './cession-section.consts';
import { CessionDataInterface } from '../../../../core/services/api/sections-api/cession-data.interface';
import { InsuranceCompanyCode } from '../../../models/insurance-company-code.enum';
import { isNotNullOrUndefined } from 'codelyzer/util/isNotNullOrUndefined';
import { SelectedOfferService } from '../../../../core/services/impl/section-services/selected-offer/selected-offer.service';
import {RegExpService} from '../../../services/reg-exp.service';

@Component({
  selector: 'app-cession-section',
  templateUrl: './cession-section.component.html',
  styleUrls: ['./cession-section.component.scss']
})
export class CessionSectionComponent extends SectionBase implements OnInit, CessionDataInterface {

  public consts = CessionSectionConsts;
  public config: CessionSectionConfig = new CessionSectionConfig();

  constructor(private stateService: CessionStateService,
              private selectedOfferService: SelectedOfferService,
              private regExpService: RegExpService) {
    super();
    this.stateService.cessionSection = this;
  }

  ngOnInit() {
    this.initBean();
    this.createConfig();
    this.buildForm();
    this.initControlsChanges();
    this.stateService.banksDictionaryEvent.subscribe(() => {
      this.setLoading(false);
      this.setItems(this.stateService.bankItems);
    });
    this.updateValidators();
  }

  get canHandle(): boolean {
    return this.isLink4() && this.selectedOfferService.hasAC();
  }

  get isCession(): boolean {
    return this.stateService.cessionData.isCession ? this.stateService.cessionData.isCession : false;
  }

  public createConfig(): void {
    this.formConfig = this.config.createCessionConfig(this.stateService, this.regExpService);
  }

  public initBean(): void {
    this.bean = {
      ...this.stateService.cessionData,
      postalCode: this.stateService.postalCodeFromState
    };
  }

  public initControlsChanges(): void {
    this.handleControlsState(
      { controlName: this.consts.IS_CESSION, behaviour: value => this.handleIsCessionChange(value) },
      { controlName: this.consts.AMOUNT, behaviour: value => this.stateService.changeAmount(value) },
      { controlName: this.consts.BANK_ID, behaviour: value => this.stateService.changeBankId(value) },
      { controlName: this.consts.POSTAL_CODE, behaviour: value => {
        if (isNotNullOrUndefined(value)) {
          if (value.length === 6) {
            this.reset();
            this.stateService.changePostalCode(value);
          } else {
            this.setItems([]);
            this.getControl(this.consts.BANK_ID).reset();
          }
        }
      }},
    );
  }

  public isSectionValid(): boolean {
    if (this.canHandle) {
      return super.isSectionValid();
    }
    return true;
  }

  public areErrors(): boolean {
    return this.canHandle ? super.areErrors() : false;
  }

  public changeAmount(amount: number): void {
  }

  public changeBankId(bankId: string): void {
  }

  private isLink4() {
    return this.stateService.insuranceCompanyCode === InsuranceCompanyCode.LINK4;
  }

  private handleIsCessionChange(isCession: boolean) {
    this.stateService.changeIsCession(isCession);

    if (isCession) {
      this.initControlsValidators(
        this.consts.BANK_ID,
        this.consts.AMOUNT,
        this.consts.POSTAL_CODE);
    } else {
      this.clearMultipleValidators(
        this.consts.BANK_ID,
        this.consts.AMOUNT,
        this.consts.POSTAL_CODE);
      this.resetMultipleControls(
        this.consts.BANK_ID,
        this.consts.AMOUNT,
        this.consts.POSTAL_CODE);

      this.setItems([]);
      this.getControl(this.consts.BANK_ID).reset();
      this.stateService.resetCessionPostalCode();
    }
  }

  /**
   * clears validators for cession details fields if cession question is not answered or false
   */
  private updateValidators(): void {
    if (!this.isCession) {
      this.clearMultipleValidators(
        this.consts.BANK_ID,
        this.consts.AMOUNT,
        this.consts.POSTAL_CODE);
    }
  }

  private reset(): void {
    this.setLoading(true);
    this.setItems([]);
    this.getControl(this.consts.BANK_ID).reset();
  }

  private setLoading(loading: boolean) {
    this.getFieldConfig(this.consts.BANK_ID).select.loadingEvent.next(loading);
  }

  private setItems(items: any[]): void {
    this.getFieldConfig(this.consts.BANK_ID).options['items'] = items;
  }
}
